export class SaleorderTypeDto {
    saleorderTypeId: number;
    saleOrderTypeName: string;
    isActive: boolean;
    createdAt : Date | any;
    createdUser : string;
    updatedAt : Date | any;
    updatedUser : string;
    versionFlag : number;
}

export const SaleorderTypeDtoDefault : SaleorderTypeDto = {
    saleorderTypeId: 0,
    saleOrderTypeName: "",
    isActive: true,
    createdAt : new Date() ,
    createdUser : '0',
    updatedAt : new Date() ,
    updatedUser : '0',
    versionFlag : 1
};

